<template>
  <main>
    <AppHeader class="breakout" />
    <slot />
  </main>
</template>

<script setup>
definePageMeta({
  middleware: 'activate-page',
})
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}
</style>
